import axios from "axios";
import { serverData, serviceUrls } from "../constant";
import {
  put,
  get,
  patch,
  post,
  del,
  createQueryParams,
} from "../../services/axiosComponent";
export const getOrganizationLevel = async (data) => {
  return await get({
    url: serviceUrls.ADMIN_SERVICE + "/organization/level/list",
    params: createQueryParams(data),
  });
};

export const updateOrganizationLevel = async (data) => {
  return await put({ url: serviceUrls.ADMIN_SERVICE + "/organization/level", data });
};

export const deleteOrganizationLevel = async (levelId) => {
  return await del({
    url: serviceUrls.ADMIN_SERVICE + "/organization/level",
    params: createQueryParams({ entityId: levelId }),
  });
};

export const addOrganizationLevel = async (data) => {
  return await post({ url: serviceUrls.ADMIN_SERVICE + "/organization/level", data });
};
